import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "accordion accordion--small",
  "data-allow-multiple": ""
}
const _hoisted_2 = {
  key: 0,
  class: "accordion__item",
  open: ""
}
const _hoisted_3 = { class: "accordion__summary" }
const _hoisted_4 = ["xlink:href"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", { class: "accordion__summary-svg" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#svg-expand" })
], -1 /* HOISTED */)
const _hoisted_6 = { class: "accordion__content" }
const _hoisted_7 = ["innerHTML"]

import { PropType, computed } from 'vue'
import { Criticality } from '../../types/enums'
import type { TravelInfoMessage } from './../../types'
import { getCurrentCulture } from './../../utilities/culture-helper'


export default /*#__PURE__*/_defineComponent({
  __name: 'TravelInfoMessages',
  props: {
  travelInfoMessages: {
    type: Array as PropType<TravelInfoMessage[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const showMessages = computed<boolean>(
  () =>
    props.travelInfoMessages.length > 0 &&
    props.travelInfoMessages.some((x) => x.isVisible)
)

const { cultureShortCode } = getCurrentCulture()

function getMessageThemeClass(travelMessage: TravelInfoMessage): string {
  switch (travelMessage.criticality) {
    default:
    case Criticality.Normal:
      return 'accordion__status-svg--success'
    case Criticality.Important:
      return 'accordion__status-svg--warning'
    case Criticality.Critical:
      return 'accordion__status-svg--danger'
  }
}
function getMessageSvgIcon(travelMessage: TravelInfoMessage): string {
  switch (travelMessage.criticality) {
    default:
    case Criticality.Normal:
      return '#svg-check'
    case Criticality.Important:
      return '#svg-warning'
    case Criticality.Critical:
      return '#svg-alert'
  }
}

function showTravelMessage(travelMessage: TravelInfoMessage): boolean {
  return (
    travelMessage.isVisible &&
    travelMessage.title[cultureShortCode]?.length > 0 &&
    travelMessage.message[cultureShortCode]?.length > 0
  )
}

return (_ctx: any,_cache: any) => {
  return (showMessages.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.travelInfoMessages, (travelMessage) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (showTravelMessage(travelMessage))
              ? (_openBlock(), _createElementBlock("details", _hoisted_2, [
                  _createElementVNode("summary", _hoisted_3, [
                    (_openBlock(), _createElementBlock("svg", {
                      class: _normalizeClass([
              'accordion__status-svg',
              getMessageThemeClass(travelMessage),
            ])
                    }, [
                      _createElementVNode("use", {
                        "xlink:href": getMessageSvgIcon(travelMessage)
                      }, null, 8 /* PROPS */, _hoisted_4)
                    ], 2 /* CLASS */)),
                    _createTextVNode(" " + _toDisplayString(travelMessage.title[_unref(cultureShortCode)]) + " ", 1 /* TEXT */),
                    _hoisted_5
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: "accordion__text",
                      innerHTML: travelMessage.message[_unref(cultureShortCode)]
                    }, null, 8 /* PROPS */, _hoisted_7)
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}
}

})